import { alpha, IconButton, Stack, styled, Tab, Tabs } from '@mui/material';

import FormDate from '../../../../components/FormDate';
import FormSelect from '../../../../components/FormSelect';
import FormText from '../../../../components/FormText';

export const TabStyled = styled(Tab)(({ theme }) => ({
  minHeight: 'unset',
  padding: theme.spacing(1, 2),
  borderRadius: theme.spacing(2),
  textTransform: 'none',
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  fontWeight: 700,
  color: theme.palette.secondary[900],
  '& svg path': {
    stroke: theme.palette.secondary[200],
  },
  '&.Mui-selected': {
    border: 0,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.neutral.main,
    '& svg path': {
      stroke: theme.palette.primary[300],
    },
  },
}));

export const EditButtonStyled = styled(IconButton)(({ theme }) => ({
  width: theme.spacing(5),
  height: theme.spacing(5),
  backgroundColor: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.9),
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.neutral.main,
    opacity: 1,
  },
}));

export const ErrorButtonStyled = styled(EditButtonStyled)(({ theme }) => ({
  backgroundColor: theme.palette.error[100],
  '&:hover': {
    backgroundColor: alpha(theme.palette.error[100], 0.9),
  },
}));

export const FormWrapperStyled = styled(Stack)(({ theme }) => ({
  overflowX: 'hidden',
  overflowY: 'auto',
  height: 'calc(100vh - 125px)',
  paddingRight: theme.spacing(1),
}));

export const FormTextStyled = styled(FormText)(({ theme }) => ({
  '& .MuiInputBase-root': {
    '& fieldset': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-disabled fieldset': {
      borderColor: theme.palette.secondary.main,
    },
    '&.Mui-disabled .MuiInputBase-input': {
      color: theme.palette.grey[900],
      '-webkit-text-fill-color': theme.palette.grey[900],
    },
  },
}));

export const FormSelectStyled = styled(FormSelect)(({ theme }) => ({
  '& fieldset': {
    borderColor: theme.palette.primary.main,
  },
  '&.MuiInputBase-root.Mui-disabled fieldset': {
    borderColor: theme.palette.secondary.main,
  },
  '&.Mui-disabled .MuiInputBase-input': {
    color: theme.palette.grey[900],
    '-webkit-text-fill-color': theme.palette.grey[900],
  },
}));

export const FormDateStyled = styled(FormDate)(({ theme }) => ({
  '& .MuiPickersInputBase-root': {
    '& fieldset': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-disabled fieldset': {
      borderColor: theme.palette.secondary.main,
    },
    '&.Mui-disabled .MuiPickersSectionList-sectionContent, &.Mui-disabled .MuiPickersInputBase-sectionAfter':
      {
        color: theme.palette.grey[900],
      },
    '&.Mui-disabled .MuiPickersInputBase-input': {
      color: theme.palette.grey[900],
      '-webkit-text-fill-color': theme.palette.grey[900],
    },
  },
}));

export const TabsCvStyled = styled(Tabs)(({ theme }) => ({
  minHeight: theme.spacing(5),
  '& .MuiTabs-list': {
    gap: theme.spacing(1),
  },
  '& .MuiButtonBase-root': {
    padding: theme.spacing(1),
    minHeight: 'unset',
    '& .MuiTypography-root': {
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        fontWeight: 700,
        color: theme.palette.secondary[200],
        textTransform: 'none',
      },
      '&.Mui-selected': {
        '& .MuiTypography-root': {
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
        fontWeight: 700,
        color: theme.palette.grey[900],
      },
    },
  },
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.grey[900],
  },
}));

export const CvTabWrapperStyled = styled(Stack)(({ theme }) => ({
  height: 'calc(100vh - 180px)',
  width: '100%',
  gap: theme.spacing(2),
}));

export const CvPreviewWrapperStyled = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.palette.neutral[200]}`,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(1),
  backgroundColor: theme.palette.neutral.main,
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: '14px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: theme.palette.primary.main,
    borderRadius: '8px',
    border: `${theme.spacing(0.5)} solid transparent`,
    backgroundClip: 'padding-box',
  },
}));
